<template>
  <b-card>
    <!-- table -->
    <vue-good-table
      ref="my-table-user"
      @on-selected-rows-change="selectionChanged"
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
    >
      <template slot="table-column" slot-scope="props">
        <span v-if="props.column.field == 'companyName'">
          <feather-icon icon="BriefcaseIcon" class="mr-50" />ผู้ประกอบการ /
          <feather-icon icon="UserIcon" class="mr-50" />ชื่อผู้ร้องทุกข์ /
          <feather-icon icon="UsersIcon" class="mr-50" /> ผู้มอบอำนาจ
        </span>
        <span v-else>
          {{ props.column.label }}
        </span>
      </template>
      <template slot="table-row" slot-scope="props">
        <span class="text-nowrap">
          <span class="text-nowrap">{{
            props.formattedRow[props.column.field]
          }}</span>
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BFormCheckboxGroup,
  BFormCheckbox, // ,BRow, BCol, BFormTextarea, BFormRadio, BTab, BTabs,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import { codeBasic } from "@/views/table/vue-good-table/code";
import store from "@/store/index";

export default {
  directives: {
    Ripple,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BFormCheckbox,
    BFormCheckboxGroup,
  },
  props: {
    rows: [],
  },
  setup(props) {
    // return {
    //   rows: props.users,
    // };
  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      codeBasic,
      columns: [
        {
          label: "ชื่อ - นามสกุล",
          field: "fullname",
        },
        {
          label: "หน่วยงาน",
          field: "orgName",
        },
        {
          label: "อีเมล",
          field: "email",
        },
        {
          label: "เบอร์โทรศัพท์",
          field: "tel",
        },
      ],
      searchTerm: "",
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {},
  methods: {
    selectionChanged() {
      console.log("ref", this.$refs);
      this.$emit("handle-select", this.$refs["my-table-user"].selectedRows);
    },
  },
};
</script>
